/**
 * Do not change this file manually! This file was generated with the "Dicebear Exporter"-Plugin for Figma.
 *
 * Plugin: https://www.figma.com/community/plugin/1005765655729342787
 */

import type { StyleSchema } from "@dicebear/core";

export const schema: StyleSchema = {
  $schema: "http://json-schema.org/draft-07/schema#",
  properties: {
    backgroundColor: {
      type: "array",
      items: {
        type: "string",
        pattern: "^(transparent|[a-fA-F0-9]{6})$",
      },
      default: ["f4f4f4", "1e4643", "e7d1ec", "353535", "2e3a59"],
    },
    bggColor: {
      type: "array",
      items: {
        type: "string",
        pattern: "^(transparent|[a-fA-F0-9]{6})$",
      },
      default: ["f4f4f4", "1e4643", "e7d1ec", "353535", "2e3a59"],
    },
    goon1: {
      type: "array",
      items: {
        type: "string",
        enum: ["1"],
      },
      default: ["1"],
    },
    goonColor: {
      type: "array",
      items: {
        type: "string",
        pattern: "^(transparent|[a-fA-F0-9]{6})$",
      },
      default: ["e63946", "457b9d", "d85f92", "e64e39", "2a9d8f", "8e44ad", "5f64d8", "618a52"],
    },
    wave1: {
      type: "array",
      items: {
        type: "string",
        enum: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
      },
      default: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
    },
    wave1Color: {
      type: "array",
      items: {
        type: "string",
        pattern: "^(transparent|[a-fA-F0-9]{6})$",
      },
      default: ["f1faee", "e9c46a", "a8dadc", "9c6644", "ffb4a2"],
    },
    wave2: {
      type: "array",
      items: {
        type: "string",
        enum: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
      },
      default: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
    },
    wave2Color: {
      type: "array",
      items: {
        type: "string",
        pattern: "^(transparent|[a-fA-F0-9]{6})$",
      },
      default: ["264653", "e76f51", "d4a373", "4a4e69", "e29578"],
    },
    wave3: {
      type: "array",
      items: {
        type: "string",
        enum: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
      },
      default: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
    },
    wave3Color: {
      type: "array",
      items: {
        type: "string",
        pattern: "^(transparent|[a-fA-F0-9]{6})$",
      },
      default: ["1d3557", "6d6875", "333533", "1b263b", "2c3e50"],
    },
  },
};
